module.exports = "<div class=\"accept-terms-modal\">\n  <div class=\"modal-body main-text\">\n    <h3>Hi,</h3>\n    <h4>\n      Thank you for using NightPro\n    </h4>\n    <p>\n      Before continuing, please accept our\n    </p>\n    <p>\n      <a ng-href=\"{{ termsUrl }}\" target=\"_blank\">Terms of Service</a>\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"confirm($event)\" ng-disabled=\"saving\">\n      {{ saving ? 'Saving' : 'I Accept' }}\n    </button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modals/acceptTerms/template.html
// module id = 1244
// module chunks = 0